import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Routes from "../Routes/Routes";
import FloatingAlerts from "../Components/Core/FloatingAlerts/FloatingAlerts";

const App = () => {
  return (
    <>
      <CssBaseline />
      <Routes />
      <FloatingAlerts />
    </>
  );
};

export default App;
